import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class NewsletterSettingsResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/newsletter_settings' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}